import { articleType } from './articleType';

// @see https://schema.org/NewsArticle
// Article and NewsArticle are just the same, and it only changes the @type field.
export const newsArticleType = content => {
  const article = articleType(content);
  if (article) {
    article['@type'] = 'NewsArticle';
  }
  return article;
};
